import React from 'react'
import { GlassCard } from 'react-glass-ui'

const GLASS_PROPS = {
  blur: 6,
  distortion: 30,
  flexibility: 0,
  borderColor: '#ffffff',
  borderSize: 1,
  borderOpacity: 0.25,
  backgroundColor: '#ffffff',
  backgroundOpacity: 0.06,
  innerLightColor: '#ffffff',
  innerLightSpread: 1,
  innerLightBlur: 12,
  innerLightOpacity: 0.2,
  outerLightColor: '#000000',
  outerLightSpread: 1,
  outerLightBlur: 16,
  outerLightOpacity: 0.15,
  color: '#ffffff',
  saturation: 100,
  brightness: 100
}

const FEATURES = [
  {
    icon: '/img/signup/game-icon.svg',
    title: 'Gamified Campaigns',
    content: 'Connect purchases, quizzes, and forecasts to boost engagement.'
  },
  {
    icon: '/img/signup/interactive-quizes.svg',
    title: 'Interactive Quizzes',
    content: 'Educate, entertain and keep your brand top of mind.'
  },
  {
    icon: '/img/signup/rewarded-ads.svg',
    title: 'Rewarded Ads',
    content: 'Boost branded content engagement and verify tracking.'
  },
  {
    icon: '/img/signup/action-driven.svg',
    title: 'Action-Driven Rewards',
    content: 'Use points, vouchers and prizes to encourage repeat visits.'
  }
]

export default function AuthMarketingPanel() {
  return (
    <div
      className="relative hidden lg:flex flex-col justify-center h-full w-full px-14 py-12 overflow-hidden bg-[#0E3A66]"
      style={{
        backgroundImage: 'url(/img/signup/bg-auth.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="relative z-10 max-w-xl mx-auto w-full">
        <GlassCard
          {...GLASS_PROPS}
          borderRadius={999}
          padding="6px 16px"
          contentClassName="inline-flex items-center gap-2"
          className="mb-8"
        >
          <img src="/img/signup/trophy-icon.svg" alt="" className="w-3.5 h-3.5" />
          <span className="text-xs font-medium text-blue-100">Gamifying commerce across Africa</span>
        </GlassCard>

        <h1 className="text-4xl font-bold text-white leading-tight mb-1">Turn Every Purchase Into</h1>
        <h1 className="text-4xl font-bold text-[#8BC6FF] leading-tight mb-4">Play, Loyalty &amp; Growth</h1>

        <p className="text-blue-100/70 text-[15px] leading-relaxed mb-10 max-w-md">
          Engage and retain customers through gamified campaigns, interactive quizzes, rewarded ads and meaningful rewards
        </p>

        <div className="grid grid-cols-2 gap-4 mb-4">
          {
            FEATURES.map(({ icon, title, content }) => (
              <GlassCard
                key={title}
                {...GLASS_PROPS}
                width="100%"
                borderRadius={16}
                padding="16px"
                contentClassName="flex items-center gap-3"
              >
                <img src={icon} alt="" className="w-9 h-9 shrink-0" />
                <div>
                  <p className="text-white text-sm font-semibold mb-1">{title}</p>
                  <p className="text-blue-100/60 text-xs leading-snug">{content}</p>
                </div>
              </GlassCard>
            ))
          }
        </div>

        <GlassCard
          {...GLASS_PROPS}
          width="100%"
          borderRadius={16}
          padding="16px"
          contentClassName="flex items-center gap-3"
        >
          <div className="w-9 h-9 rounded-xl overflow-hidden shrink-0">
            <img src="/img/signup/track.svg" alt="" className="w-full h-full object-cover" />
          </div>
          <p className="text-blue-100/70 text-sm">Track campaign participation, sales and customer activity in real time</p>
        </GlassCard>
      </div>
    </div>
  )
}
